const currencyFee = {
  AUD: 0.30,
  BRL: 0.60,
  CAD: 0.30,
  CZK: 10.0,
  DKK: 2.60,
  EUR: 0.35,
  HKD: 2.35,
  HUF: 90.0,
  ILS: 1.20,
  JPY: 40.0,
  MYR: 2.0,
  MXN: 4.0,
  TWD: 10.0,
  NZD: 0.45,
  NOK: 2.80,
  PHP: 15.0,
  PLN: 1.35,
  RUB: 10.0,
  SGD: 0.50,
  SEK: 3.25,
  CHF: 0.55,
  THB: 11.0,
  GBP: 0.20,
  USD: 0.30,
};

const getProcessingFee = (amount, currency, country, _type, _promoted) => {
  const countryFee = country === 'US' ? 0.03 : 0.045;

  const paymentProcessingFee = Math.ceil((countryFee * amount + currencyFee[currency]) * 100.0) / 100.0;

  return paymentProcessingFee;
};

const getServiceFee = (amount, _currency, _country, type, promoted) => {
  let serviceFee = type === 1 ? amount * 0.015 : amount * 0.025;
  serviceFee = Math.ceil(serviceFee * 100.0) / 100.0;
  if (serviceFee < 0.09) {
    serviceFee = 0.09;
  }
  if (promoted) {
    serviceFee *= 2.0;
  }

  return serviceFee;
};

export default {
  getProcessingFee,
  getServiceFee,
};
